import { useState } from 'react';
import { useEclipsePanorama } from '../../../hooks';
import { useCurrentModule } from '../../ModuleProvider';
export const useInitSuccess = function (checkoutKey) {
  if (checkoutKey === void 0) {
    checkoutKey = '';
  }
  const [initializedKey, setInitializedKey] = useState(null);
  const [hasReportedLoad, setHasReportedLoad] = useState(false);
  const [eventAggregator, setEventAggregator] = useState(undefined);
  const panorama = useEclipsePanorama();
  const module = useCurrentModule();
  const handleInitSuccess = orderPageEventAggregator => {
    if (!hasReportedLoad) {
      panorama.finishTransaction('checkout-page-load', {
        eventAggregator: orderPageEventAggregator
      });
      module.internals.bi.onCheckoutPageLoad == null || module.internals.bi.onCheckoutPageLoad({
        eventAggregator: orderPageEventAggregator
      });
      setHasReportedLoad(true);
    }
    setEventAggregator(orderPageEventAggregator);
    setInitializedKey(checkoutKey);
  };
  return {
    eventAggregator,
    handleInitSuccess,
    didInitSuccess: initializedKey === checkoutKey
  };
};
//# sourceMappingURL=useInitSuccess.js.map